import { launchTutorialv1 } from "../../../Features/tutorialv1";

console.info("Onboarding script initialized!");
document.addEventListener("DOMContentLoaded", () => {
    launchTutorialv1();
});

export {};
